/* eslint-disable import/prefer-default-export */
import { createSelector } from "reselect";
import { getPageContent } from "shared/selectors/base";

export const getProductsMetaData = createSelector(
  [getPageContent],
  pageContent => pageContent.products_meta_data || {}
);
